import OwnershipPageComponent from 'components/OwnershipPageComponent'

export default OwnershipPageComponent
